// extracted by mini-css-extract-plugin
export var fadeIn = "NavigationLinksBurger-module--fadeIn--3ZfSu";
export var fadeInAnime = "NavigationLinksBurger-module--fadeInAnime--3y-Uu";
export var fadeOut = "NavigationLinksBurger-module--fadeOut--3X3Ui";
export var fadeOutAnime = "NavigationLinksBurger-module--fadeOutAnime--UPNtM";